import { Stack, Text } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form/lib/use-form';
import { BusinessTypes } from '../../enums/business-type';
import { UpdateMerchantOnboardingFormValues } from '../../type/update-merchant-onboarding-form-values.types';
import UpdateMainOfficeContactInfo from './components/update-general-info-components/update-main-office-contact-info.component';
import UpdateMerchantDescription from './components/update-general-info-components/update-merchant-description.component';
import UpdateMechantInfo from './components/update-general-info-components/update-merchant-info.component';
import RegisteredContactInfoUpdate from './components/update-general-info-components/update-registered-contact-info.component';
import UpdateWebsiteLinks from './components/update-general-info-components/update-website-links';

interface GeneralInfoUpdateNewProps {
  form: UseFormReturnType<UpdateMerchantOnboardingFormValues>;
  setBusinessHandleError: React.Dispatch<React.SetStateAction<string>>;
  businessHandleError: string;
  isNonAdminInterface: boolean;
}
function UpdateGeneralInfo(props: GeneralInfoUpdateNewProps) {
  const {
    form,
    businessHandleError,
    setBusinessHandleError,
    isNonAdminInterface,
  } = props;

  return (
    <>
      <Stack>
        <Text size='xl' weight={700}>
          General Information
        </Text>
        <UpdateMechantInfo
          form={form}
          businessHandleError={businessHandleError}
          setBusinessHandleError={setBusinessHandleError}
          isNonAdminInterface={isNonAdminInterface}
        />
        {form.values.businessTypeId !== BusinessTypes.STARTER &&
          !isNonAdminInterface && <RegisteredContactInfoUpdate form={form} />}
        <UpdateMainOfficeContactInfo form={form} />
        <UpdateMerchantDescription
          form={form}
          isNonAdminInterface={isNonAdminInterface}
        />
        <UpdateWebsiteLinks form={form} />
      </Stack>
    </>
  );
}

export default UpdateGeneralInfo;
